import {
  GET_SESSION,
  GET_SESSION_SUCCESS,
  GET_SESSION_UNAVAILABLE,
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILURE,
  LOGIN,
  LOGIN_FAILURE,
  LOGOUT,
  API_ERROR
} from "./actionTypes"

const initialState = {
  error: "",
  userDetails: null,
  settings: null,
  settingsError: null,
  // "timeout" | "network" | "server" while the API cannot confirm the session.
  sessionUnavailable: null,
  sessionPending: false,
  loading: false,
  loginPending: false,
  loginError: "",
}

const session = (state = initialState, action) => {
  switch (action.type) {
    case GET_SESSION:
      state = {
        ...state,
        loading: true,
        sessionPending: true,
      }
      break
    case GET_SESSION_UNAVAILABLE:
      state = { ...state, loading: false, sessionPending: false, sessionUnavailable: action.payload }
      break
    case LOGIN:
      state = {
        ...state,
        loading: true,
        loginPending: true,
        loginError: "",
      }
      break
    case LOGIN_FAILURE:
      state = { ...state, loading: false, loginPending: false, loginError: action.payload }
      break
    case LOGOUT:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SESSION_SUCCESS:
      state = {
        ...state,
        loading: false,
        sessionPending: false,
        sessionUnavailable: null,
        userDetails: action.payload,
        loginPending: false,
        loginError: "",
      }
      break
    case GET_SETTINGS:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SETTINGS_SUCCESS:
      state = {
        ...state,
        loading: false,
        settings: action.payload,
        settingsError: null,
      }
      break
    case GET_SETTINGS_FAILURE:
      state = { ...state, loading: false, settingsError: action.payload }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, userDetails: {}, loading: false, sessionPending: false, sessionUnavailable: null }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default session
